module.exports = __webpack_public_path__ + "static/img/qrcode.34899edd.png";